import {registerReactPartial} from '@github-ui/react-core/register-partial'
import {AutomatedReviewCommentActions} from './components/AutomatedReviewCommentActions'

registerReactPartial('automated-review-comment-actions', {
  Component: AutomatedReviewCommentActions,
})
